import { useCallback } from 'react';
import uuid from 'uuid/v1';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { COMPARISON_OPERATOR, LOGICAL_OPERATOR } from '../utils/subscriptionConsts';

const createNewFilter = () => ({
    id: uuid(),
    newValueCriterion: null,
    newComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
    logicalOperator: LOGICAL_OPERATOR.AND,
    previousValueCriterion: null,
    previousComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
});

export const useFilters = () => {
    const { value: filters, onChange: setFilters } = useFormFieldValue({ field: 'filters' });

    const addFilter = () => {
        setFilters([...filters, createNewFilter()]);
    };

    const deleteFilter = useCallback(
        index => {
            setFilters(filters.filter((_, i) => i !== index));
        },
        [filters, setFilters]
    );

    return { filters, setFilters, addFilter, deleteFilter };
};
